export default __webpack_public_path__ + "static/media/8k.54c93f7c.png";